"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var withLayoutContext_exports = {};
__export(withLayoutContext_exports, {
  useFilterScreenChildren: () => useFilterScreenChildren,
  useResolvedGuardedRedirects: () => useResolvedGuardedRedirects,
  withLayoutContext: () => withLayoutContext
});
module.exports = __toCommonJS(withLayoutContext_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"), 1);
var import_matchers = require("../router/matchers");
var import_Route = require("../router/Route");
var import_router = require("../router/router");
var import_useScreens = require("../router/useScreens");
var import_sortRoutes = require("../router/sortRoutes");
var import_withStaticProperties = require("../utils/withStaticProperties");
var import_Protected = require("../views/Protected");
var import_Screen = require("../views/Screen");
var import_StackScreen = require("./stack-utils/StackScreen");
function _type_of(obj) {
  "@swc/helpers - typeof";
  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function useFilterScreenChildren(children) {
  var { isCustomNavigator, contextKey } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (
    /** Used for sending developer hints */
    {}
  );
  return import_react.default.useMemo(function() {
    var customChildren = [];
    var screens = [];
    var protectedScreens = /* @__PURE__ */ new Set();
    var guardedRedirects = /* @__PURE__ */ new Map();
    function flattenChild(child) {
      var exclude = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, redirectTo = arguments.length > 2 ? arguments[2] : void 0;
      if (/* @__PURE__ */ import_react.default.isValidElement(child) && (child.type === import_Screen.Screen || child.type === import_StackScreen.StackScreen)) {
        if (_type_of(child.props) === "object" && child.props && "name" in child.props && !child.props.name) {
          throw new Error(`<Screen /> component in \`default export\` at \`app${contextKey}/_layout\` must have a \`name\` prop when used as a child of a Layout Route.`);
        }
        if (process.env.NODE_ENV !== "production") {
          if ([
            "children",
            "component",
            "getComponent"
          ].some(function(key) {
            return child.props && _type_of(child.props) === "object" && key in child.props;
          })) {
            throw new Error(`<Screen /> component in \`default export\` at \`app${contextKey}/_layout\` must not have a \`children\`, \`component\`, or \`getComponent\` prop when used as a child of a Layout Route`);
          }
        }
        var screenProps = child.props;
        if (exclude && screenProps.name) {
          protectedScreens.add(screenProps.name);
          guardedRedirects.set(screenProps.name, redirectTo);
        } else {
          screens.push(screenProps);
        }
        return;
      }
      if ((0, import_Protected.isProtectedElement)(child)) {
        var guardFails = !child.props.guard;
        var excludeChildren = exclude || guardFails;
        var childRedirectTo = guardFails ? child.props.redirectTo : redirectTo;
        import_react.default.Children.forEach(child.props.children, function(nested) {
          flattenChild(nested, excludeChildren, childRedirectTo);
        });
        return;
      }
      if (isCustomNavigator) {
        customChildren.push(child);
      } else if (child != null && process.env.NODE_ENV === "development") {
        console.warn(`[one] a non-<Screen> child of the navigator at "app${contextKey}/_layout" renders on web only. On native this navigator is drawn by react-navigation and the child is ignored.`);
      }
    }
    import_react.default.Children.forEach(children, function(child) {
      return flattenChild(child);
    });
    if (process.env.NODE_ENV !== "production") {
      var names = screens.map(function(screen) {
        return screen.name;
      });
      if (names && new Set(names).size !== names.length) {
        throw new Error("Screen names must be unique: " + names);
      }
    }
    return {
      screens,
      children: customChildren,
      protectedScreens,
      guardedRedirects
    };
  }, [
    children,
    contextKey,
    isCustomNavigator
  ]);
}
function useResolvedGuardedRedirects(guardedRedirects) {
  var node = (0, import_Route.useRouteNode)();
  return import_react.default.useMemo(function() {
    if (!node) {
      return guardedRedirects;
    }
    var defaultRoute = [
      ...node.children
    ].sort((0, import_sortRoutes.sortRoutesWithInitial)(node.initialRouteName)).find(function(child) {
      var normalized = child.route.replace(/\/index$/, "");
      return !(guardedRedirects.has(child.route) || guardedRedirects.has(normalized));
    });
    var defaultHref = defaultRoute ? (0, import_matchers.stripInvisibleSegmentsFromPath)((0, import_matchers.getContextKey)(defaultRoute.contextKey)) || "/" : void 0;
    return new Map(Array.from(guardedRedirects, function(param) {
      var [name, redirectTo] = param;
      return [
        name,
        redirectTo !== null && redirectTo !== void 0 ? redirectTo : defaultHref
      ];
    }));
  }, [
    guardedRedirects,
    node
  ]);
}
function withLayoutContext(Nav, processor, options) {
  return (0, import_withStaticProperties.withStaticProperties)(/* @__PURE__ */ import_react.default.forwardRef(function(propsIn, ref) {
    var { children, ...props } = propsIn;
    var contextKey = (0, import_Route.useContextKey)();
    var { screens, protectedScreens, guardedRedirects } = useFilterScreenChildren(children, {
      contextKey
    });
    var resolvedGuardedRedirects = useResolvedGuardedRedirects(guardedRedirects);
    (0, import_router.registerProtectedRoutes)(contextKey, resolvedGuardedRedirects);
    var currentPathname = import_router.routeInfo === null || import_router.routeInfo === void 0 ? void 0 : import_router.routeInfo.pathname;
    var protectedHref = currentPathname ? (0, import_router.resolveProtectedHref)(currentPathname) : currentPathname;
    import_react.default.useEffect(function() {
      (0, import_router.registerProtectedRoutes)(contextKey, resolvedGuardedRedirects);
      return function() {
        (0, import_router.unregisterProtectedRoutes)(contextKey);
      };
    }, [
      contextKey,
      resolvedGuardedRedirects
    ]);
    import_react.default.useEffect(function() {
      if (currentPathname && protectedHref && protectedHref !== currentPathname) {
        (0, import_router.replace)(protectedHref);
      }
    }, [
      currentPathname,
      protectedHref
    ]);
    var processed = processor ? processor(screens !== null && screens !== void 0 ? screens : []) : screens;
    var sorted = (0, import_useScreens.useSortedScreens)(processed !== null && processed !== void 0 ? processed : [], {
      onlyMatching: true,
      protectedScreens
    });
    if (!sorted.length) {
      return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Nav, {
      ...options === null || options === void 0 ? void 0 : options.props,
      ...props,
      id: contextKey,
      ref,
      children: sorted
    });
  }), {
    Screen: import_Screen.Screen
  });
}
//# sourceMappingURL=withLayoutContext.js.map
